'use strict';

angular.module('ufcw')
  .controller('HomefirstController', function ($log,Request,$localstorage,$state,$rootScope,toaster,$uibModal,$document,EnvConfig,$window,$translate) {
    var vm = this;

    $rootScope.headLander = true;
    
    vm.errorMsg = null;
    vm.user  = $localstorage.getObject('user');
    
    vm.show_msg = $localstorage.get('showMsg');

    vm.alerts  = $localstorage.getObject('alerts');
    vm.showAlerts = (vm.alerts.length>0)?true:false;
    vm.useRoutines = $localstorage.get('useRoutines');
    $rootScope.titulopagina = "";

    vm.loadGridItems = function(){
      Request.get('appconfiguration?id='+EnvConfig.COMPANY_ID,false,function(response) {
        if(response.status !== 0){
          toaster.pop('info', "", $translate.instant('api.'+response.description));
        }else{
          vm.griditems = response.description.griditems;
        }
      });
    };

    vm.loadGridItems();

  });